<template>
  <div class="h-bottombar">
    <div class="my-outbox" ref="outbox" @mouseenter="stopMarquee" @mouseleave="startMarquee">
      <div class="my-inbox" ref="box" v-if="isReloadData">
        <div class="my-list" @click="showNotice" v-for="(item, index) in send" v-cloak :key="index" ref="list">
          <span class="my-uname">{{ item.info }}</span>
        </div>
      </div>
    </div>
    <div class="h-bottombar-span">
      <span v-show="showMarket">交易状态：{{ statusName }} </span>
      <img class="my-notice" src="" alt="" @click="showNotice" title="消息" />
      <span>{{ showTime }}</span>
    </div>
    <div class="h-bottombar-info" v-bind:style="{display:showInfo}" ref="info">
      <div class="notice-header-info">
        <div class="notice-image-info">
          <img src="../../assets/notice.png" /><span>通知提示</span>
        </div>
        <div class="notice-close-info">
          <img src="../../assets/notice-close.png" alt="" @click="closeBtnInfo" />
        </div>
      </div>
      <div style="width:100%;height:89%;background-color: #e7e7e7;">
        <p style="color:blue;">{{infoOne}}</p>
        <p align="left"
          style="height: 158px;line-height:20px;overflow-y:auto; overflow-x:hidden;word-wrap: break-word;word-break: break-all;white-space:break-spaces">
          {{infoTwo}}</p>
      </div>
    </div>
    <h-msg-box v-model="noticeInfo" :closable="false" :mask-closable="false" :isBeyond='true' width="610" class="notice-info">
      <div slot="header" class="notice-header">
        <div class="notice-image">
          <img src="../../assets/notice.png" /><span>最新公告</span>
        </div>
        <div class="notice-close">
          <img src="../../assets/notice-close.png" alt="" @click="closeBtnNotice" title="关闭" />
        </div>
      </div>
      <div class="notice-body-info">
        <div style="width:100%;height:89%;background-color: #e7e7e7;">
          <div style="background-color: white;width: 588px;margin-left: 5px;margin-top: 5px;vertical-align: middle;">
            <p style="color:blue;height:30px;overflow: hidden;
                          position: relative;
                          display: table-cell;
                          text-align: center;
                          vertical-align: middle;
                          width: 588px;" v-html="infoFour"></p>
          </div>
          <p align="left"
            style="height: 300px;line-height:20px;overflow-y:auto; overflow-x:hidden;word-wrap: break-word;word-break: break-all;white-space:break-spaces"
            v-html="infoFive">
          </p>
        </div>
        <h-checkbox style="margin-left:8px;" v-model="isShow" @on-change="change">不再提示</h-checkbox>
        <div class="btn">
          <h-button :disabled='disableOne' @click="previou">上一条</h-button>
          <h-button :disabled='disableTwo' @click="next">下一条</h-button>
        </div>
      </div>
      <div slot="footer"></div>
    </h-msg-box>
    <h-msg-box v-model="show" :closable="false" :mask-closable="false" :isBeyond='true' width="1000" class="notice">
      <div slot="header" class="notice-header">
        <div class="notice-image">
          <img src="../../assets/notice.png" /><span>消息中心</span>
        </div>
        <div class="notice-close">
          <img src="../../assets/notice-close.png" alt="" @click="closeBtn" title="关闭" />
        </div>
      </div>
      <div class="notice-body">
        <div class="notice-body-left">
          <h-tabs size="small" v-model="selectName" @on-click="dataReload">
            <h-tab-pane label="公告" name="name1"></h-tab-pane>
            <!-- <h-tab-pane label="通知" name="name2"></h-tab-pane> -->
            <!-- <h-tab-pane label="资讯" name="name3"></h-tab-pane> -->
          </h-tabs>
          <div style="margin-left: 10px;">
            <h-table border :data="tData" :showTitle="true" :columns="columns" :height="330" highlight-row="true" @on-row-click="rowClick"
              @on-select="rowClick"></h-table>
            <br />
            <h-page small style="width:505px;" :current="currentPage" :page-size-opts="[5,10, 20,50,100]" :total="totalNum"
              @on-change="dataChange" @on-page-size-change="sizeChange" @on-reload="dataReload" show-total show-sizer fastArrival
              :page-size="pageSize"></h-page>
          </div>
        </div>
        <div class="notice-body-middle">
          <div style="float:left;margin-top: 0px;width: 2px;height: 444px; background: darkgray;"></div>
        </div>
        <div class="notice-body-right">
          <h-form :model="formLeft" label-position="left" :label-width="68" cols="2" style="width:300px;margin-left:10px;">
            <div style="margin-left:-145px;">
              <h-form-item label="公告标题：" cols="2">
                <span style="width:366px;" v-text="title" readonly></span>
              </h-form-item>
              <h-form-item label="发布时间：">
                <span style="width:143px;" v-text="createTime" readonly></span>
              </h-form-item>
              <h-form-item cols="2">
                <div style="border:1px solid #CCC;margin-left:-68px;"></div>
              </h-form-item>
              <h-form-item cols="2">
                <p align="left"
                  style="margin-left: -68px;height:305px;line-height: 20px;word-wrap: break-word; word-break: break-all;overflow-y:auto; overflow-x:hidden;white-space:break-spaces"
                  v-html="infoThree">
                </p>
              </h-form-item>
            </div>
          </h-form>
        </div>
      </div>
      <div slot="footer"></div>
    </h-msg-box>
  </div>
</template>
<script>
import { getNotice } from '@frame/api/login/index'
import { getServerTime } from '@frame/api/chart/chart'
var columns = [
  {
    title: '编号',
    key: 'code',
    fixed: 'left',
    align: 'center',
    width: 60
  },
  {
    title: '市场',
    key: 'market',
    fixed: 'left',
    align: 'center',
    width: 140,
    ellipsis: true
  },
  {
    title: '标题',
    key: 'title',
    fixed: 'left',
    align: 'center',
    // width: 360,
    ellipsis: true
  }
]
const marketStatus = {
  'TRADE': '交易',
  'BREAK': '休市',
  'ENDTR': '闭市',
  'START': '闭市'
}
export default {
  name: 'Bottombar',
  data () {
    return {
      time: '',
      nowTime: null, // 定时器标识
      disArr: [], // 每一个内容的宽度
      show: false,
      selectName: 'name1',
      send: [],
      tData: [],
      columns: columns,
      totalNum: 0,
      title: '',
      createName: '',
      createTime: '',
      publishTime: '',
      infoOne: '',
      infoTwo: '',
      infoThree: '',
      infoFour: '',
      infoFive: '',
      pageSize: 10,
      pageNum: 1,
      tabName: 'name1',
      selectData: [],
      showInfo: 'none',
      isReloadData: true,
      timerOne: null,
      timerTwo: null,
      timerThree: null,
      timerFour: null,
      test: false,
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      noticeTime: 60000,
      currentPage: 1,
      noticeInfo: false,
      isShow: false,
      pos: 0,
      disableOne: false,
      disableTwo: false,
      lockTime: 0,
      marqueeTime: 0,
      totalDis: 0,
      lastStartOffset: 0,
      lastEndOffset: 0,
      queryNotice: false,
      queryAdvisory: false,
      statusCode: 'ENDTR',
      showMarket: false,
      pageOpts: [],
      totalTime: 0,
      currDate: '',
      currTime: ''
    }
  },
  computed: {
    statusName () {
      return marketStatus[this.statusCode]
    },
    showTime () {
      return `${this.currDate} ${this.currTime}`
    }
  },
  methods: {
    currentTime () {
      let date = new Date()
      let ldt = this.getLocalDate(date)
      let h = date.getHours()
      h = h < 10 ? '0' + h : h
      let m = date.getMinutes()
      m = m < 10 ? '0' + m : m
      let s = date.getSeconds()
      s = s < 10 ? '0' + s : s
      this.currDate = ldt
      this.currTime = h + ':' + m + ':' + s
    },
	getLocalDate (date) {
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      return `${y}-${m}-${d}`
    },
    showSystemTime (h, m, s) {
      let date = new Date()
      this.currDate = this.currDate || this.getLocalDate(date)
      h = h < 10 ? '0' + h : h
      m = m < 10 ? '0' + m : m
      s = s < 10 ? '0' + s : s
      this.currTime = h + ':' + m + ':' + s
      this.totalTime += 1
      // 600s，即10分钟同步一次
      if (this.totalTime % 600 == 0) {
        this.syncServerTime()
      }
    },
    getNextTimeNumber (h, m, s) {
      if (++s == 60) {
        s = 0
      }
      if (s == 0) {
        if (++m == 60) {
          m = 0
        }
        if (m == 0) {
          if (++h == 24) {
            h = 0
          }
        }
      }
      return [h, m, s]
    },
    updateLocalTime () {
      this.timerOne = setInterval(() => {
        let ts = this.currTime.split(":", 3)
        let tms = [parseFloat(ts[0]), parseFloat(ts[1]), parseFloat(ts[2])]
        tms = this.getNextTimeNumber(tms[0], tms[1], tms[2])
        this.showSystemTime(tms[0], tms[1], tms[2])
        this.sendEvt('updateSystemTime', tms)
      }, 1000)
    },
    // 获取margin属性
    getMargin (obj) {
      if (!obj) return 0
      var marg = window.getComputedStyle(obj, null)['margin-right']
      marg = marg.replace('px', '')
      return Number(marg) // 强制转化成数字
    },
    // 滚动处理
    marquee (startDis = 0, endDis = -0.1) {
      const that = this, box = this.$refs.box
      const outbox = that.$refs.outbox
      that.nowTime = setInterval(function () {
        if (endDis === -0.1 || (endDis < 0 && Math.abs(endDis) > outbox.clientWidth)) {
          endDis = that.totalDis
        }
        startDis -= 0.5
        endDis -= 0.5
        if (Math.abs(startDis) > Math.abs(that.disArr[0])) {
          that.disArr.push(that.disArr.shift())
          startDis = 0
        }
        that.lastStartOffset = startDis
        that.lastEndOffset = endDis
        box.style = 'transform: translateX(' + endDis + 'px)' // 每次都让盒子移动指定的距离
      }, that.lockTime)
    },
    // 移动的方法
    moveLeft () {
      var that = this
      var startDis = 0 // 初始位置
      var endDis = -0.1
      // this.lockTime = 1000 / ((that.$refs.outbox.clientWidth + that.totalDis) * 2 / this.marqueeTime)
      this.lockTime = this.marqueeTime / 10
      that.marquee(startDis, endDis)
    },
    // 开始滚动
    startMarquee () {
      this.marquee(this.lastStartOffset, this.lastEndOffset)
    },
    // 停止滚动
    stopMarquee () {
      if (this.nowTime) {
        clearInterval(this.nowTime)
      }
    },
    // 弹出公告窗口
    showNotice () {
      this.showInfo = 'inline'
      this.show = true
      this.dataReload(this.tabName)
    },
    // 关闭公告窗口
    closeBtn () {
      this.show = false
      this.selectName = 'name1'
      this.tabName = 'name1'
      this.pageNum = 1
    },
    // 关闭通知窗口
    closeBtnInfo () {
      this.showInfo = 'none'
      var info = this.$refs.info
      info.style = 'transform: translateX(' + 0 + 'px)'
      clearInterval(this.timerThree)
      this.timerThree = null
      clearInterval(this.timerTwo)
      this.timerTwo = null
    },
    // 关闭公告提示窗口
    closeBtnNotice () {
      this.noticeInfo = false
    },
    sizeChange (num) {
      this.pageSize = num
      this.handleChange(this.tabName)
    },
    dataChange (i) {
      this.pageNum = i
      this.tData = JSON.parse(JSON.stringify(this.selectData.slice((this.pageNum - 1) * this.pageSize, this.pageNum * this.pageSize)))
      this.tData[0]._checked = true
      this.rowClick(this.tData)
    },
    dataReload (name) {
      this.tabName = name
      this.sizeChange(this.pageSize)
      this.dataChange(this.pageNum)
    },
    handleChange (name) {
      if (name === 'name1') {
        this.columns[2].width = 360
        this.columns[1].hiddenCol = false
        this.selectData = this.data1
      } else if (name === 'name2') {
        this.columns[2].width = 440
        this.columns[1].hiddenCol = true
        this.selectData = this.data2
      } else {
        this.columns[2].width = 360
        this.columns[1].hiddenCol = false
        this.selectData = this.data3
      }
      this.totalNum = this.selectData.length
      if (this.selectData.length > 0) {
        this.tData = JSON.parse(JSON.stringify(this.selectData.slice(0, this.pageSize)))
        this.title = this.selectData[0].title
        this.createName = this.selectData[0].name
        this.createTime = this.selectData[0].time
        this.publishTime = this.selectData[0].time
        this.infoThree = this.selectData[0].info
      }
    },
    rowClick (event) {
      this.title = event[0].title
      this.createName = event[0].name
      this.createTime = event[0].time
      this.infoThree = event[0].info
    },
    notice () {
      // debugger
      var that = this
      getNotice('1').then((r) => {
        const data = r.data
        if (data.errorNo === '0') {
          that.data1 = []
          that.send = []
          for (var i = 0; i < data.totalItem; i++) {
            that.data1.push({
              name: data.items[i].createOperator,
              code: data.items[i].id,
              market: data.items[i].marketName,
              title: data.items[i].noticeTitle,
              info: data.items[i].noticeContent,
              time: data.items[i].publisherTime,
              _checked: (i === 0)
            })
            that.send.push({ info: data.items[i].noticeTitle })
          }
          that.reload()
        }
      }).catch(e => {
        console.error(e)
      })
      this.queryNotice && getNotice('2').then((r) => {
        const data = r.data
        if (data.errorNo === '0') {
          that.data2 = []
          for (var i = 0; i < data.totalItem; i++) {
            that.data2.push({
              name: data.items[i].createOperator,
              code: data.items[i].id,
              market: data.items[i].marketName,
              title: data.items[i].noticeTitle,
              info: data.items[i].noticeContent,
              time: data.items[i].publisherTime,
              _checked: (i === 0)
            })
          }
        }
      }).catch(e => {
        console.error(e)
      })
      this.queryAdvisory && getNotice('3').then((r) => {
        const data = r.data
        if (data.errorNo === '0') {
          that.data3 = []
          for (var i = 0; i < data.totalItem; i++) {
            that.data3.push({
              name: data.items[i].createOperator,
              code: data.items[i].id,
              market: data.items[i].marketName,
              title: data.items[i].noticeTitle,
              info: data.items[i].noticeContent,
              time: data.items[i].publisherTime,
              _checked: (i === 0)
            })
          }
        }
      }).catch(e => {
        console.error(e)
      })
    },
    reload () {
      this.isReloadData = false
      clearInterval(this.nowTime) // 页面关闭清除定时器
      this.nowTime = null // 清除定时器标识
      this.test = true
      this.$nextTick(() => {
        this.isReloadData = true
      })
    },
    change (event) {
      this.isShow = !event
      this.$localStore.set('isShow', this.isShow)
    },
    previou () {
      if (this.data1.length > 0) {
        if (this.data1.length > 1) {
          this.pos--
          if (this.pos === -1 || this.pos === 0) {
            this.disableOne = true
            this.pos = 0
          }
          this.disableTwo = false
        }
        this.infoFour = this.data1[this.pos].title
        this.infoFive = this.data1[this.pos].info
      } else {
        this.disableOne = true
        this.disableTwo = true
      }
    },
    next () {
      this.pos++
      if (this.pos === (this.data1.length - 1)) {
        this.disableTwo = true
      }
      this.disableOne = false
      this.infoFour = this.data1[this.pos].title
      this.infoFive = this.data1[this.pos].info
    },
    received (keys) {
      keys = Array.isArray(keys) ? keys : [keys]
      for (const key of keys) {
        this.$bus.$on(key, val => {
          let methods = this.$options.methods
          if (methods[key]) {
            methods[key].call(this, val)
          }
        })
      }
    },
    busOff (keys) {
      keys = Array.isArray(keys) ? keys : [keys]
      for (const key of keys) {
        this.$bus.$off(key)
      }
    },
    // 接受行情推送数据，更新市场交易状态
    ctlMainInit (val) {
      let keys
      if (val && (keys = Object.keys(val)).length) {
        const item = val[keys[0]]
        this.statusCode = item.status
      }
    },
    // 更新市场交易状态
    updateMarket (val) {
      if (val && val.length) {
        const item = val[0]
        this.statusCode = item.tradeStatus
        this.showMarket = true
      }
    },
    hiddenMarket (val) {
      this.showMarket = false
    },
	syncServerTime () {
      getServerTime().then(r => {
        if (r && r.data) {
          const { serverDate, serverTime } = r.data
          this.currDate = r.data.serverDate
          this.currTime = r.data.serverTime.split(" ")[1]
        }
      }).catch(e => {
        console.log(e)
      })
    },
	sendEvt (key, value) {
      this.$bus.$emit(key, value)
    }
  },
  beforeDestroy () {
    clearInterval(this.nowTime)
    this.nowTime = null
    clearInterval(this.timerOne)
    this.nowTitimerOneme = null
    clearInterval(this.timerTwo)
    this.timerTwo = null
    clearInterval(this.timerThree)
    this.timerThree = null
    clearInterval(this.timerFour)
    this.timerFour = null
    // 取消接受事件
    this.busOff(['ctlMainInit', 'updateMarket'])
  },
  updated () {
    if (this.test) {
      var item = this.$refs.list
      if (typeof (item) !== 'undefined' && item.length) {
        this.previou()
        // 显示公告 noticeInfo
        if (typeof (this.$localStore.get('isShow')) !== 'undefined') {
          this.isShow = this.$localStore.get('isShow')
          if (this.isShow) {
            this.noticeInfo = true
            this.isShow = false
          }
          this.marqueeTime = this.$localStore.get('marquee')
        }
        var len = this.send.length
        var arr = [], totalMargin = 0
        var margin = this.getMargin(item[0]) // 因为设置的margin值一样，所以取第一个就行。
        for (var i = 0; i < len; i++) {
          let dis = item[i].clientWidth + margin
          totalMargin += dis
          arr.push(dis) // 把宽度和 margin 加起来就是每一个元素需要移动的距离
        }
        this.disArr = arr
        this.totalDis = totalMargin
        this.moveLeft()
        this.test = false
      }
    }
  },
  mounted () {
    // 接受事件
    this.received(['ctlMainInit', 'updateMarket', 'hiddenMarket'])
    let sn = this.$localStore.get('showNum')
    if (typeof (sn) !== 'undefined') {
      this.pageSize = sn
    }
    this.currentTime()
    this.updateLocalTime()
    this.notice()
    var that = this
    that.timerTwo = setInterval(function () {
      that.closeBtnInfo()
      if (that.data4.length > 0) {
        that.infoOne = that.data4[0].title
        that.infoTwo = that.data4[0].info
        that.data4.push(that.data4.shift())
        var startDis = 0 // 初始位置
        that.timerThree = setInterval(function () {
          var info = that.$refs.info
          if (Math.abs(startDis) === 300) {
            startDis = 300
          } else {
            startDis -= 2
            info.style = 'transform: translateX(' + startDis + 'px)'
          }
        }, 1000 / 60)
      }
    }, that.noticeTime)
    that.timerFour = setInterval(function () {
      that.notice()
    }, 1000 * that.$localStore.get('notice'))
  }
}
</script>

<style scoped>
.h-bottombar {
  background: #131520;
  z-index: 1000;
  width: 100%;
  height: 21px;
  line-height: 20px;
  margin-top: 7px;
  position: fixed;
  bottom: 0;
  left: 0;
  font-size: 12px;
}
.h-bottombar-span {
  float: left;
  width: 274px;
  background: #131520;
  display: flex;
  justify-content: flex-end;
}
.h-bottombar-span span {
  color: #ccc9c5;
  margin-left: 10px;
  margin-right: 10px;
}
.h-bottombar-info {
  width: 300px;
  height: 200px;
  float: right;
  background-image: url('../../assets/ucf_light_title_background.png');
  margin-top: -202px;
  margin-right: -300px;
  transform: translateX(0px);
}
.my-outbox {
  color: #d7bc8d;
  overflow: hidden;
  height: 20px;
  line-height: 20px;
  float: left;
  background: #131520;
  width: calc(100% - 274px);
}
.my-outbox .my-inbox {
  white-space: nowrap;
  float: right;
  transform: translateX(10000000px);
}
.my-inbox .my-list {
  margin-right: 25px;
  display: inline-block;
}
[v-cloak] {
  display: none !important;
}
.my-list .my-uname {
  color: #ccc9c5;
}
.my-list:hover {
  cursor: pointer;
}
.my-notice {
  /* float: left; */
  /* left: 282px; */
  margin-top: 3px;
  /* margin-left: 135px; */
  width: 15px;
  height: 15px;
  background-position: center;
  -webkit-app-region: no-drag;
  outline: none;
  background-image: url(../../assets/info.png);
  background-size: 100% 100%;
}
.my-notice:hover {
  border-top-right-radius: 2px;
  background-position: center;
  -webkit-app-region: no-drag;
  background-image: url(../../assets/info1.png);
  cursor: pointer;
}
.notice /deep/ .h-modal-content {
  height: 482px !important; /**540 */
  border-radius: 0px !important;
  /* border: 3px solid black !important; */
  background-image: url('../../assets/ucf_light_title_background.png');
}
.notice /deep/ .h-modal-header {
  border-bottom: 0px solid #f7f7f7 !important;
}
.notice /deep/ .h-modal-footer {
  border-top: 0px solid #f7f7f7 !important;
  padding: 0px !important;
}
.notice-header {
  margin-top: -8px;
  margin-left: -11px;
}
.notice-image {
  float: left;
}
.notice-image img {
  width: 20px;
  vertical-align: middle;
  -webkit-app-region: no-drag;
}
.notice-image span {
  color: white;
  padding-left: 8px;
  font-size: 14px;
  vertical-align: middle;
}
.notice-close {
  float: right;
  margin-top: -6px;
  margin-right: -16px;
}
.notice-close img {
  width: 30px;
  vertical-align: middle;
}
.notice-close:hover {
  background-color: red;
}
.notice-header-info {
  margin-top: 23px;
  margin-left: -11px;
}
.notice-image-info {
  float: left;
  margin-top: -22px;
  margin-left: 18px;
}
.notice-image-info img {
  width: 15px;
  vertical-align: middle;
  -webkit-app-region: no-drag;
}
.notice-image-info span {
  padding-left: 8px;
  font-size: 12px;
  vertical-align: middle;
}
.notice-close-info {
  float: right;
  margin-top: -23px;
  margin-right: 0px;
}
.notice-close-info img {
  width: 20px;
  vertical-align: middle;
}
.notice-close-info:hover {
  background-color: red;
  cursor: pointer;
}
.notice-body {
  width: 985px;
  height: 445px; /**500*/
  border: 1px solid #999;
  margin-top: -30px;
  margin-left: -25px;
  background-color: #e7e7e7;
}
.notice-body-left {
  float: left;
}
.notice-body-middle {
  float: left;
  margin-left: 10px;
}
.notice-body-right {
  margin-top: 18px;
  float: right;
}
.notice-body-right /deep/ .h-form-item-label {
  background: none !important;
}
.notice-body /deep/ .h-tabs {
  margin-left: 10px !important;
  height: 0% !important;
  min-height: 60px !important;
  width: 195px !important;
}
.notice-body /deep/ .h-tabs-ink-bar {
  width: 48px !important;
}
.notice-body /deep/ .h-tabs-bar {
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}
.notice-body /deep/ .h-table-wrapper {
  width: 508px !important;
}
.notice-body /deep/ .h-page {
  margin-top: -13px !important;
}
.notice-body /deep/ .h-page-total {
  margin-right: 2px !important;
}
.notice-body /deep/ .h-page-options {
  display: unset !important;
  margin-left: -1px !important;
}
.notice-info /deep/ .h-modal-content {
  height: 410px !important;
  border-radius: 0px !important;
  background-image: url('../../assets/ucf_light_title_background.png');
}
.notice-info /deep/ .h-modal-header {
  border-bottom: 0px solid #f7f7f7 !important;
}
.notice-info /deep/ .h-modal-footer {
  border-top: 0px solid #f7f7f7 !important;
  padding: 0px !important;
}
.notice-body-info {
  width: 600px;
  height: 375px;
  border: 1px solid #999;
  margin-top: -30px;
  margin-left: -27px;
  background-color: #e7e7e7;
}
.btn {
  margin-left: 435px;
  width: 150px;
  margin-top: -20px;
}
.btn /deep/ .h-btn {
  margin-left: 5px !important;
}
.notice-body-right >>> table th,
.notice-body-right >>> table td {
  border: 1px solid #8f8f94 !important;
  padding: 0;
}
.notice-body-left /deep/ .h-table-body {
  height: 280px !important;
}
</style>
